import { NavLink } from 'react-router-dom';

import { type NavigationLink } from '~/shared/config/navigation-links';
import { Button } from '~/shared/ui/button';

type Properties = React.AnchorHTMLAttributes<HTMLAnchorElement> &
  NavigationLink;

export function NavigationButton({
  to,
  linkText,
  icon,
  className,
  ...properties
}: Properties) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) => {
        return isActive ? `active group ${className}` : className;
      }}
      end
      {...properties}
    >
      <Button variant="navigation" width="full" justify="start">
        {icon && icon}
        {linkText}
      </Button>
    </NavLink>
  );
}
